module.exports = __webpack_public_path__ + "static/floral 10 3000x3000-dbcbb60533299dca852af99a8767fa89.jpg";